import { MOCK_COURSES, type CourseSystem, type ICourse, type ICourseDay } from './courses';

/** Single-day course collections must select the requested muscle group rather than their first entry. */
export function selectGymTrainingDay(system: CourseSystem, label: string, dayIndex: number): { course: ICourse; day: ICourseDay } {
  const personalId = /核心|腹/.test(label) ? 'personal-abs'
    : /胸|推/.test(label) ? 'personal-chest'
    : /背|拉/.test(label) ? 'personal-back'
    : /腿|蹲/.test(label) ? 'personal-legs'
    : /肩/.test(label) ? 'personal-shoulders' : 'personal-arms-1';
  let course: ICourse | undefined;
  if (system === 'personal') course = MOCK_COURSES.find(item => item.id === personalId);
  if (system === 'four-way' && /^手臂/.test(label)) course = MOCK_COURSES.find(item => item.id === 'personal-arms-2');
  if (system === 'ksw-collection') {
    const id = /核心|腹/.test(label) ? 'personal-abs' : /背|拉/.test(label) ? 'ksw-collection-pull'
      : /腿|蹲/.test(label) ? 'ksw-collection-legs' : 'ksw-collection-push';
    course = MOCK_COURSES.find(item => item.id === id);
  }
  course ||= MOCK_COURSES.find(item => item.system === system && item.id !== 'personal-stretch') || MOCK_COURSES[0];
  const index = system === 'four-way' && course.days.length === 4
    ? /胸|推/.test(label) ? 0 : /背|拉/.test(label) ? 1 : /腿|蹲/.test(label) ? 2 : 3
    : (dayIndex - 1) % course.days.length;
  const day = course.days[index];
  if (system === 'ksw-collection' && /上肢/.test(label)) {
    const pullDay = MOCK_COURSES.find(item => item.id === 'ksw-collection-pull')?.days[0];
    if (pullDay) return {
      course,
      day: { ...day, name: '上肢强化', focus: '胸 · 背 · 肩 · 臂',
        mainIds: [...new Set([...day.mainIds.slice(0, 3), ...pullDay.mainIds.slice(0, 3)])],
        warmupIds: [...new Set([...day.warmupIds, ...pullDay.warmupIds])],
        stretchIds: [...new Set([...day.stretchIds, ...pullDay.stretchIds])] },
    };
  }
  return { course, day };
}
